import {
  SetToken,
} from "akademika/akamont/services/AuthService";

import { UpdateLanguageFromAccessToken } from "akademika/akamont/utils/LanguageUtil";
import { TokenResponse } from "akademika/akamont/models/TokenResponse";
import BaseController from "../sharedControllers/BaseController";
import PasswordInput from "../../customControls/PasswordInput";
import { Routes } from "akademika/akamont/constants/Routes";
import JSONModel from "sap/ui/model/json/JSONModel";
import Input from "sap/m/Input";

/**
 * @namespace akademika.akamont.pages.login
 */
export default class Login extends BaseController {
  route = Routes.LOGIN;

  public onRouteMatched(): void | Promise<void> {
    this.setModel(new JSONModel({}), "loginForm");
  }

  public async login(): Promise<void> {
    const userInput = this.byId("userNameInput") as Input;
    const pwInput = this.byId("passwordInput") as PasswordInput;

    pwInput.syncFromDom();

    const userDom = userInput.getFocusDomRef() as HTMLInputElement | null;
    const pwDom = pwInput.getFocusDomRef() as HTMLInputElement | null;

    const loginForm = {
      userName: userDom?.value || userInput.getValue(),
      password: pwDom?.value || pwInput.getValue(),
    };

    const loginResp = await this.post<TokenResponse>("api/Auth/Login", {
      body: loginForm,
      checkToken: false,
    });

    SetToken(loginResp);
    UpdateLanguageFromAccessToken(loginResp.accessToken, true);

    if (this.routeParams.returnRoute) {
      let returnArgs: Record<string, string> | undefined = undefined;
      if (this.routeParams.returnArgs) {
        returnArgs = JSON.parse(decodeURI(this.routeParams.returnArgs));
      }
      this.navTo(this.routeParams.returnRoute, returnArgs);
    } else this.navTo(Routes.DASHBOARD);
  }
}
